(function () {
  if (window.__FP_ZIP_GLOBAL_LOADED__) return;
  window.__FP_ZIP_GLOBAL_LOADED__ = true;

  const FP_EXPRESS_COVERAGE_ZIPS = new Set([
    '44100','44110','44130','44140','44150','44158','44160','44170','44180','44190',
    '44200','44210','44214','44215','44216','44217','44218','44219','44220','44227',
    '44230','44240','44246','44247','44249','44250','44257','44259','44260','44265',
    '44266','44267','44270','44280','44290','44298','44299','44300','44306','44307',
    '44320','44329','44330','44340','44350','44360','44370','44380','44390','44395',
    '44398','44399','44400','44410','44419','44420','44430','44440','44450','44460',
    '44467','44469','44470','44490','44493','44500','44510','44520','44530','44535',
    '44538','44540','44549','44550','44559','44560','44580','44600','44610','44619',
    '44620','44630','44635','44647','44648','44650','44656','44657','44658','44660',
    '44665','44667','44668','44670','44678','44679','44680','44689','44690','44700',
    '44710','44716','44719','44720','44723','44724','44725','44726','44727','44729',
    '44730','44737','44739','44740','44748','44750','44755','44757','44760','44765',
    '44766','44768','44769','44770','44780','44790','44799','44800','44810','44815',
    '44817','44818','44820','44824','44825','44827','44828','44829','44840','44860',
    '44870','44890','44895','44897','44898','44899','44900','44910','44918','44919',
    '44920','44929','44930','44940','44948','44950','44956','44959','44960','44966',
    '44967','44969','44970','44977','44978','44980','44984','44985','44986','44987',
    '44989','44990','45010','45012','45014','45015','45016','45017','45018','45019',
    '45020','45027','45030','45034','45036','45037','45038','45039','45040','45047',
    '45049','45050','45053','45054','45055','45056','45057','45058','45059','45060',
    '45065','45066','45067','45068','45069','45070','45076','45077','45078','45079',
    '45080','45085','45086','45087','45088','45089','45100','45110','45116','45117',
    '45118','45119','45120','45128','45129','45130','45133','45134','45136','45138',
    '45140','45145','45146','45147','45148','45149','45150','45157','45158','45159',
    '45160','45167','45168','45169','45170','45176','45177','45178','45179','45180',
    '45184','45185','45186','45187','45188','45189','45190','45198','45199','45205',
    '45222','45226','45230','45234','45235','45236','45237','45238','45239','45402',
    '45403','45404','45405','45408','45412','45500','45509','45510','45519','45520',
    '45525','45527','45528','45530','45535','45540','45550','45559','45560','45567',
    '45570','45579','45580','45588','45589','45590','45593','45594','45595','45596',
    '45597','45598','45599','45600','45601','45602','45604','45605','45606','45607',
    '45608','45609','45610','45613','45615','45618','45619','45620','45623','45625',
    '45626','45628','45629','45643','45647','45655','45690','45692','45693'
  ]);

  const FP_ZIP_STORAGE_KEYS = {
    zip: 'fp_user_zip',
    express: 'fp_user_zip_express',
    checkedAt: 'fp_user_zip_checked_at'
  };

  document.addEventListener('DOMContentLoaded', bootGlobalZip);
  document.addEventListener('shopify:section:load', bootGlobalZip);

  function bootGlobalZip() {
    paintHeaderChips();
    paintZipCards();
    bindGlobalZipModal();
    if (!window.__FP_ZIP_UPDATED_BOUND__) {
      window.addEventListener('fp:zip-updated', paintHeaderChips);
      window.addEventListener('fp:zip-updated', function () {
        paintHeaderChips();
        paintZipCards();
      });
    }
  }


  function getStoredZipState() {
    try {
      return {
        zip: window.localStorage.getItem(FP_ZIP_STORAGE_KEYS.zip) || '',
        isExpress: window.localStorage.getItem(FP_ZIP_STORAGE_KEYS.express) === 'true'
      };
    } catch (error) {
      return { zip: '', isExpress: false };
    }
  }

  function storeZipValidation(zip, isExpress) {
    try {
      window.localStorage.setItem(FP_ZIP_STORAGE_KEYS.zip, zip);
      window.localStorage.setItem(FP_ZIP_STORAGE_KEYS.express, isExpress ? 'true' : 'false');
      window.localStorage.setItem(FP_ZIP_STORAGE_KEYS.checkedAt, String(Date.now()));
    } catch (error) {}
  }

  function validateExpressZip(zip, expressMinutes) {
    if (!/^\d{5}$/.test(zip)) {
      return {
        ok: false,
        validFormat: false,
        message: 'Ingresa un código postal válido de 5 dígitos.'
      };
    }
    if (FP_EXPRESS_COVERAGE_ZIPS.has(zip)) {
      return {
        ok: true,
        validFormat: true,
        message: `Sí, tu código postal entra en nuestra cobertura express de hasta ${expressMinutes} minutos. Finaliza tu compra y nuestro equipo validará la ventana disponible para enviarlo hoy.`
      };
    }
    return {
      ok: false,
      validFormat: true,
      message: 'Por ahora este código postal no entra en nuestra cobertura express, pero sí podemos enviarlo con entrega estándar.'
    };
  }

  function renderGlobalZipResult(resultEl, message, state) {
    if (!resultEl) return;
    resultEl.textContent = message;
    resultEl.hidden = false;
    resultEl.classList.remove('is-hidden', 'is-success', 'is-error');
    resultEl.classList.add(state === 'success' ? 'is-success' : 'is-error');
  }

  function hideGlobalZipResult(resultEl) {
    if (!resultEl) return;
    resultEl.textContent = '';
    resultEl.hidden = true;
    resultEl.classList.add('is-hidden');
    resultEl.classList.remove('is-success', 'is-error');
  }

  function paintHeaderChips() {
    const chips = Array.from(document.querySelectorAll('[data-fp-header-zip-chip]'));
    if (!chips.length) return;
    const stored = getStoredZipState();
    const modal = document.querySelector('[data-fp-global-zip-modal]');
    const expressMinutes = modal?.dataset?.expressMinutes || '120';
    const isSmallViewport = typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(max-width: 360px)').matches;
    chips.forEach((chip) => {
      const label = chip.querySelector('[data-fp-header-zip-chip-text]');
      chip.classList.remove('is-express', 'is-standard', 'is-empty');
      if (!stored.zip) {
        chip.classList.add('is-empty');
        if (label) label.textContent = isSmallViewport ? '¿Te llega hoy?' : '¿Te llega hoy? Ingresa tu CP';
        return;
      }
      if (stored.isExpress) {
        chip.classList.add('is-express');
        if (label) label.textContent = `Express ${expressMinutes} min a CP ${stored.zip}`;
      } else {
        chip.classList.add('is-standard');
        if (label) label.textContent = `Envío estándar a CP ${stored.zip}`;
      }
    });
  }

  function paintZipCards() {
    const wraps = Array.from(document.querySelectorAll('[data-fp-zip-proof-wrap]'));
    if (!wraps.length) return;

    const stored = getStoredZipState();
    const showExpress = !!(stored.zip && stored.isExpress);

    wraps.forEach((wrap) => {
      const expressProof = wrap.querySelector('[data-fp-express-proof]');
      const defaultProofs = Array.from(wrap.querySelectorAll('[data-fp-default-proof]'));
      const emptyClass = wrap.dataset.fpProofEmptyClass || '';

      if (!expressProof) return;

      const hasFreeShippingDefault = defaultProofs.some((item) => {
        const label = (item.textContent || '').trim().toLowerCase();
        return label === 'envío gratis' || label === 'envio gratis';
      });

      if (showExpress) {
        expressProof.textContent = hasFreeShippingDefault
          ? 'Express gratis en tu zona'
          : 'Express en tu zona';

        expressProof.classList.remove('is-hidden');
        defaultProofs.forEach((item) => item.classList.add('is-hidden'));

        if (emptyClass) wrap.classList.remove(emptyClass);
        wrap.removeAttribute('aria-hidden');
        return;
      }

      expressProof.textContent = 'Express en tu zona';
      expressProof.classList.add('is-hidden');
      defaultProofs.forEach((item) => item.classList.remove('is-hidden'));

      if (defaultProofs.length === 0) {
        if (emptyClass) wrap.classList.add(emptyClass);
        wrap.setAttribute('aria-hidden', 'true');
      } else {
        if (emptyClass) wrap.classList.remove(emptyClass);
        wrap.removeAttribute('aria-hidden');
      }
    });
  }
  function bindGlobalZipModal() {
    const modal = document.querySelector('[data-fp-global-zip-modal]');
    const input = document.querySelector('[data-fp-global-zip-input]');
    const resultEl = document.querySelector('[data-fp-global-zip-result]');
    const coverageExpress = document.querySelector('[data-fp-zip-coverage-express]');
    const coverageStandard = document.querySelector('[data-fp-zip-coverage-standard]');
    const clearWrap = modal?.querySelector('[data-fp-zip-clear-wrap]');
    const clearButton = modal?.querySelector('[data-fp-global-clear-zip]');
    const openers = Array.from(document.querySelectorAll('[data-fp-open-global-zip-modal]'));
    const closers = Array.from(document.querySelectorAll('[data-fp-global-close-zip-modal]'));
    const checkButton = document.querySelector('[data-fp-global-check-zip]');
    if (!modal || !input || !resultEl || !openers.length || !checkButton) return;
    if (modal.dataset.fpGlobalBound === 'true') return;
    modal.dataset.fpGlobalBound = 'true';
    const expressMinutes = modal.dataset.expressMinutes || '120';
    const paintCoverage = () => {
      const stored = getStoredZipState();
      coverageExpress?.classList.toggle('is-active', !!(stored.zip && stored.isExpress));
      coverageStandard?.classList.toggle('is-active', !!(stored.zip && !stored.isExpress));
      if (clearWrap) clearWrap.hidden = !stored.zip;
    };
    const openModal = () => {
      input.value = getStoredZipState().zip || '';
      hideGlobalZipResult(resultEl);
      paintCoverage();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('fp-zip-modal-open');
      window.setTimeout(() => input.focus(), 50);
    };
    const closeModal = () => {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('fp-zip-modal-open');
    };
    openers.forEach((opener) => {
      opener.addEventListener('click', (event) => {
        event.preventDefault();
        openModal();
      });
    });
    closers.forEach((closer) => {
      closer.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal();
      });
    });
    const handleValidation = () => {
      const zip = (input.value || '').replace(/\D/g, '').trim();
      const validation = validateExpressZip(zip, expressMinutes);
      if (!validation.validFormat) {
        renderGlobalZipResult(resultEl, validation.message, 'error');
        return;
      }
      hideGlobalZipResult(resultEl);
      storeZipValidation(zip, validation.ok);
      paintHeaderChips();
      paintZipCards();
      paintCoverage();
      window.dispatchEvent(new CustomEvent('fp:zip-updated', {
        detail: {
          zip,
          isExpress: validation.ok
        }
      }));
    };
    if (clearButton) {
      clearButton.addEventListener('click', () => {
        try {
          window.localStorage.removeItem(FP_ZIP_STORAGE_KEYS.zip);
          window.localStorage.removeItem(FP_ZIP_STORAGE_KEYS.express);
          window.localStorage.removeItem(FP_ZIP_STORAGE_KEYS.checkedAt);
        } catch (error) {}
        input.value = '';
        hideGlobalZipResult(resultEl);
        paintHeaderChips();
        paintZipCards();
        paintCoverage();
        window.dispatchEvent(new CustomEvent('fp:zip-updated', {
          detail: {
            zip: '',
            isExpress: false
          }
        }));
        window.setTimeout(() => input.focus(), 50);
      });
    }
    checkButton.addEventListener('click', handleValidation);
    input.addEventListener('input', () => {
      input.value = (input.value || '').replace(/\D/g, '').slice(0, 5);
      coverageExpress?.classList.remove('is-active');
      coverageStandard?.classList.remove('is-active');
      hideGlobalZipResult(resultEl);
    });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        handleValidation();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (modal.hidden) return;
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  }
})();
